import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../services/api";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const [form,    setForm]    = useState({ email: "", password: "" });
  const [error,   setError]   = useState("");
  const [loading, setLoading] = useState(false);
  const { loginCtx } = useAuth();
  const navigate     = useNavigate();

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await login(form);
      loginCtx(data.token, data.user);
      // Si el alumno debe cambiar su contraseña, redirigir obligatoriamente
      if (data.user.must_change_password) {
        navigate("/set-password");
      } else {
        navigate(data.user.role === "admin" ? "/admin" : "/");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:"100vh", background:"var(--bg)", display:"flex", alignItems:"center", justifyContent:"center", padding:"2rem" }}>
      <div style={{ background:"var(--white)", border:"0.5px solid var(--border)", borderRadius:12, padding:"2.5rem 2rem", width:"100%", maxWidth:420 }}>
        <h1 style={{ fontFamily:"var(--font-display)", fontWeight:800, fontSize:"1.3rem", color:"var(--teal-dark)", marginBottom:"1.5rem", textAlign:"center", letterSpacing:1 }}>
          INICIAR SESIÓN
        </h1>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Correo electrónico</label>
            <input name="email" type="email" value={form.email} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>Contraseña</label>
            <input name="password" type="password" value={form.password} onChange={handleChange} required />
          </div>
          {error && <p className="form-error">{error}</p>}
          <button type="submit" className="btn-primary" disabled={loading} style={{ width:"100%", padding:"10px", marginTop:".5rem", fontSize:"0.85rem" }}>
            {loading ? "Entrando..." : "Iniciar Sesión"}
          </button>
        </form>
      </div>
    </div>
  );
}